import type { Point2d } from "."
import type { Edge2dComputed } from "../mesh"

export const findMidpoint = (e: Edge2dComputed): Point2d => ({
  x: (e.p1.x + e.p2.x) / 2,
  y: (e.p1.y + e.p2.y) / 2,
})
